import { useState } from "react";

// ─── DATA ─────────────────────────────────────────────────────────────────────

const TABS = ["All", "Schooling", "UG", "PG", "Computer"];

const COURSES = [
  // Schooling
  { title: "10th Correspondence", kn: "10ನೇ ತರಗತಿ", sub: "SSLC", desc: "Secondary education for private candidates.", tag: "Govt Approved", category: "Schooling" },
  { title: "12th Correspondence", kn: "12ನೇ ತರಗತಿ", sub: "PUC",  desc: "Pre-university Arts / Commerce stream.",   tag: "Direct Entry",  category: "Schooling" },

  // UG
  { title: "BA",    kn: "ಬಿ.ಎ",     sub: "Arts",      desc: "History, Kannada, English & more.",       tag: "3 Years",    category: "UG" },
  { title: "B.Com", kn: "ಬಿ.ಕಾಂ",   sub: "Commerce",  desc: "Accounting and business foundation.",      tag: "Online",     category: "UG" },
  { title: "BCA",   kn: "ಬಿಸಿಎ",    sub: "Computers", desc: "Programming and IT management.",           tag: "Job Ready",  category: "UG" },
  { title: "B.Sc",  kn: "ಬಿ.ಎಸ್ಸಿ", sub: "Science",   desc: "Theoretical foundation in science.",       tag: "Flexible",   category: "UG" },
  { title: "B.Lib", kn: "ಬಿ.ಲಿಬ್",  sub: "Library",   desc: "Library and info management training.",    tag: "1 Year",     category: "UG" },

  // PG
  { title: "MA",    kn: "ಎಂ.ಎ",     sub: "Masters",    desc: "Advanced literature & social sciences.",   tag: "2 Years",     category: "PG" },
  { title: "M.Com", kn: "ಎಂ.ಕಾಂ",   sub: "Masters",    desc: "Finance and advanced accounting.",         tag: "Corporate",   category: "PG" },
  { title: "MBA",   kn: "ಎಂಬಿಎ",    sub: "Management", desc: "Global leadership and business strategy.", tag: "High Growth",  category: "PG" },
  { title: "M.Sc",  kn: "ಎಂ.ಎಸ್ಸಿ", sub: "Science",    desc: "Research and scientific methodology.",     tag: "Research",    category: "PG" },
  { title: "MCA",   kn: "ಎಂಸಿಎ",    sub: "Software",   desc: "Professional software development.",       tag: "Tech Career", category: "PG" },
  { title: "M.Lib", kn: "ಎಂ.ಲಿಬ್",  sub: "Library",    desc: "Info science and archiving.",              tag: "Expert",      category: "PG" },

  // Computer
  { title: "Basic Tally Prime", kn: "ಬೇಸಿಕ್ ಟ್ಯಾಲಿ ಪ್ರೈಮ್", sub: "Accounts", desc: "GST, ledgers, inventory, payroll & banking reports.", tag: "6 Months", category: "Computer" },
];

const TAG_COLOR = {
  "Govt Approved": "bg-green-50 text-green-700",
  "Direct Entry":  "bg-blue-50 text-blue-700",
  "Job Ready":     "bg-emerald-50 text-emerald-700",
  "Tech Career":   "bg-purple-50 text-purple-700",
  "High Growth":   "bg-orange-50 text-orange-700",
  "6 Months":      "bg-amber-50 text-amber-700",
};
const defaultTag = "bg-gray-100 text-gray-500";

// ─── COURSE CARD ──────────────────────────────────────────────────────────────

function Card({ course }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 hover:border-red-200 hover:shadow-sm transition-all flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h4 className="text-base font-bold text-gray-900">{course.title}</h4>
          <p className="text-xs text-red-600 mt-0.5" style={{ fontFamily: "'Noto Sans Kannada', sans-serif" }}>
            {course.kn}
          </p>
        </div>
        <span className="text-xs font-bold bg-gray-50 text-gray-500 border border-gray-100 px-2.5 py-0.5 rounded-full shrink-0">
          {course.sub}
        </span>
      </div>

      <p className="text-sm text-gray-500 leading-relaxed">{course.desc}</p>

      <div className="flex items-center justify-between mt-auto pt-2">
        <span className={`text-xs font-bold px-2.5 py-0.5 rounded-full ${TAG_COLOR[course.tag] || defaultTag}`}>
          {course.tag}
        </span>
        <button className="text-sm font-semibold text-red-700 hover:text-red-900 transition-colors">
          Details →
        </button>
      </div>
    </div>
  );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────

export default function DistanceEducation() {
  const [activeTab, setActiveTab] = useState("All");
  const filtered = COURSES.filter(c => activeTab === "All" || c.category === activeTab);

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Noto+Sans+Kannada:wght@400;600&display=swap');`}</style> */}

      {/* Top banner */}
      <div className="bg-red-700 text-white text-center py-2.5">
        <p className="text-sm font-semibold tracking-wide">
          Admissions Open for 2025-26 · 2025-26 ನೇ ಸಾಲಿಗೆ ಪ್ರವೇಶ ಆರಂಭ
        </p>
      </div>

      <div className="w-full px-4 sm:px-8 py-12">

        {/* ── HEADING ── */}
        <div className="text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-2">
            Distance and &amp; <span className="text-red-700">Online Education</span>
          </h2>
          <p className="text-base text-red-600" style={{ fontFamily: "'Noto Sans Kannada', sans-serif" }}>
            ಪತ್ರವ್ಯವಹಾರ ಮತ್ತು ಆನ್‌ಲೈನ್ ಶಿಕ್ಷಣ
          </p>
        </div>

        {/* ── TABS (centered) ── */}
        <div className="flex justify-center mb-8">
          <div className="flex flex-wrap justify-center gap-2 bg-white border border-gray-100 rounded-xl p-2">
            {TABS.map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-2.5 rounded-lg text-sm font-bold transition-colors ${
                  activeTab === tab
                    ? "bg-red-700 text-white"
                    : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* ── GRID ── */}
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
            {filtered.map(course => (
              <Card key={course.title} course={course} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-gray-400">
            <p className="text-4xl mb-3">📚</p>
            <p className="text-base">No courses found · ಯಾವುದೇ ಕೋರ್ಸ್ ಕಂಡುಬಂದಿಲ್ಲ</p>
          </div>
        )}

        {/* ── CTA BANNER ── */}
        <div className="mt-12 bg-red-700 rounded-2xl p-6 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-red-200 mb-1.5">
              Free Counseling · ಉಚಿತ ಸಮಾಲೋಚನೆ
            </p>
            <h3 className="text-white font-extrabold text-xl sm:text-2xl">Need guidance? We're here.</h3>
            <p className="text-red-200 text-sm mt-1" style={{ fontFamily: "'Noto Sans Kannada', sans-serif" }}>
              ನಮ್ಮ ತಜ್ಞರು ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ಸಿದ್ಧರಿದ್ದಾರೆ
            </p>
          </div>
          <div className="flex flex-col sm:items-end gap-3 shrink-0">
            <p className="text-amber-400 font-extrabold text-2xl">+91 99644 51828</p>
            <div className="flex gap-3">
              <a href="tel:+919964451828"
                className="bg-white text-red-700 font-bold text-sm px-5 py-3 rounded-xl hover:bg-red-50 transition-colors shadow-sm">
                📞 Call Now
              </a>
              <button className="bg-amber-400 hover:bg-amber-300 text-gray-900 font-bold text-sm px-5 py-3 rounded-xl transition-colors shadow-sm">
                Enquire · ವಿಚಾರಿಸಿ
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}